<template lang="pug">
server-data(
  v-model="nominations"
  :method="getEventNominations"
  :serialize-data-items="serializeNominationsItems"
  start-loading-value
  v-slot="{ loading }"
)
  template(v-if="loading")
    text-loader(:is-init="false")
  template(v-else)
    h2.text-none.text-h5.font-weight-bold.redesignBlack--text Требования организатора
    p.text-body-1.redesignBlack--text.mt-4 Для регистрации на мероприятие заполните свои данные
    v-sheet(
      rounded="xl"
      flat
    ).mt-8.pa-8
      api-form(
        v-model="formData"
        :method="(args) => method(args, null)"
        :fields="fields"
        :observer-props="{ vid }"
        no-reset
        hide-save-btn
      )
        template(#requirements.actions="props")
          portal-target(
            :name="`${stepId}-actions`"
            :slot-props="{ ...props, loading: props.form.loading, action: props.form.action }"
          )
</template>

<script>
import ManyApiForms from '@/components/global/ManyApiForms.vue';
import ExtraUserRequirementsForm from '@/components/forms/ExtraUserRequirementsForm.vue';
import { PER_PAGE } from '@/constants/pagination';
import Nomination from '@/models/list/nomination';

export default {
  name: 'RequirementsForm',
  components: {
    ManyApiForms,
    ExtraUserRequirementsForm,
  },
  props: {
    stepId: {
      type: [String, Number],
      required: true,
    },
    vid: {
      type: String,
      required: true,
    },
    event: {
      type: Object,
      required: true,
    },
    method: {
      type: Function,
      required: true,
    },
    globalFields: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      formData: this.value,
      nominations: [],
    };
  },
  computed: {
    fields() {
      const { event, nominations, globalFields } = this;

      return [
        {
          value: 'requirements',
          component: ExtraUserRequirementsForm,
          component_attrs: {
            event,
            nominations,
            'fields-settings': {
              first_name: { required: true },
              last_name: { required: true },
              middle_name: { required: false },
              // birthday_at: { required: true },
            },
            'additional-fields': globalFields,
          },
          component_events: {
            fieldsData: (val) => {
              this.$emit('fieldsData', val);
            },
            updated: () => {
              this.$emit('updated');
            },
          },
        },
      ];
    },
  },
  watch: {
    value(val) {
      this.formData = val;
    },
    formData(val) {
      this.$emit('input', val);
    },
  },
  methods: {
    getEventNominations() {
      const { event } = this;

      const params = {
        'search[event_id]': event.id,
        'per-page': PER_PAGE.infinity,
        expand: 'groups',
        sort: 'id',
      };

      return this.$rApi.eventNominations.getAll({ params });
    },
    serializeNominationsItems(data) {
      return data.map((nomination) => new Nomination(nomination)).map((nomination) => ({
        ...nomination,
        selected_groups: (nomination?.groups || []).map((group) => ({
          ...group,
          directory_attributes: (group?.attributes || []),
        })),
      }));
    },
  },
};
</script>
